<template>
  <div class="card overflow-hidden">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-2 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
        </svg>
        依恋模式类型
      </div>
      <div class="text-center pt-2">
        <div 
          class="w-20 h-20 rounded-full flex items-center justify-center text-5xl mx-auto mb-4"
          :style="{ 
            backgroundColor: hexToRgba(primaryType.color, 0.082),
            border: `3px solid ${primaryType.color}`
          }"
        >
          {{ primaryType.emoji }}
        </div>
        <h3 
          class="text-3xl sm:text-4xl font-bold"
          :style="{ color: primaryType.color }"
        >
          {{ primaryType.name }}
        </h3>
      </div>
    </div>
    <div class="p-6 pt-0 space-y-6">
      <!-- 次要类型 -->
      <div v-if="attachmentType.secondary" class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-100">
        <h4 class="font-semibold text-sm mb-2 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: attachmentType.secondary.color }">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
          次要类型：{{ attachmentType.secondary.name }}
        </h4>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{ getSecondaryDescription() }}
        </p>
      </div>

      <!-- 核心特征 -->
      <div>
        <h4 class="font-semibold text-sm mb-3 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: primaryType.color }">
            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
            <path d="M20 3v4"></path>
            <path d="M22 5h-4"></path>
            <path d="M4 17v2"></path>
            <path d="M5 18H3"></path>
          </svg>
          核心特征
        </h4>
        <div class="grid grid-cols-2 gap-2">
          <div 
            v-for="(feature, index) in primaryType.characteristics"
            :key="index"
            class="flex items-center gap-2 text-sm px-3 py-2 rounded-lg"
            :style="{ backgroundColor: hexToRgba(primaryType.color, 0.03) }"
          >
            <div 
              class="w-1.5 h-1.5 rounded-full flex-shrink-0"
              :style="{ backgroundColor: primaryType.color }"
            ></div>
            <span class="text-gray-600">{{ feature }}</span>
          </div>
        </div>
      </div>

      <!-- 关系模式 -->
      <div class="bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-xl p-5 border border-gray-200">
        <h4 
          class="font-semibold text-base mb-3 flex items-center gap-2"
          :style="{ color: primaryType.color }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
          关系模式
        </h4>
        <p class="text-sm text-gray-700 leading-relaxed">
          {{ getRelationshipPattern() }}
        </p>
      </div>

      <!-- 恋爱优势 -->
      <div>
        <h4 class="font-semibold text-sm mb-3 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: primaryType.color }">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
          </svg>
          恋爱优势
        </h4>
        <ul class="space-y-2">
          <li 
            v-for="(strength, index) in primaryType.strengthsInLove"
            :key="index"
            class="flex items-start gap-2 text-sm text-gray-600"
          >
            <span class="text-green-500 mt-0.5">✓</span>
            <span>{{ strength }}</span>
          </li>
        </ul>
      </div>

      <!-- 挑战 -->
      <div>
        <h4 class="font-semibold text-sm mb-3 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: primaryType.color }">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          需要注意
        </h4>
        <ul class="space-y-2">
          <li 
            v-for="(challenge, index) in primaryType.challenges"
            :key="index"
            class="flex items-start gap-2 text-sm text-gray-600"
          >
            <span class="text-orange-500 mt-0.5">⚠</span>
            <span>{{ challenge }}</span>
          </li>
        </ul>
      </div>

      <!-- 建议 -->
      <div class="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-4 border border-blue-100">
        <h4 class="font-semibold text-sm mb-2 flex items-center gap-2 text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" :style="{ color: primaryType.color }">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
          </svg>
          给你的建议
        </h4>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{ getAdvice() }}
        </p>
      </div>

      <div class="pt-4 border-t border-gray-200">
        <p class="text-xs text-gray-500 text-center leading-relaxed">
          依恋类型基于 Bowlby 和 Ainsworth 的依恋理论，通过四维度得分推测。
          依恋模式并非固定不变，通过自我觉察和努力可以向安全型转化。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttachmentType',
  props: {
    attachmentType: {
      type: Object,
      required: true
    },
    assessmentType: {
      type: String,
      default: 'self'
    }
  },
  computed: {
    primaryType() {
      return this.attachmentType.primary
    }
  },
  methods: {
    hexToRgba(hex, alpha) {
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    getDescription() {
      const type = this.assessmentType === 'self' ? 'self' : 'partner'
      return this.primaryType.description[type] || this.primaryType.description.self
    },
    getSecondaryDescription() {
      if (!this.attachmentType.secondary) return ''
      const type = this.assessmentType === 'self' ? 'self' : 'partner'
      return this.attachmentType.secondary.secondaryDescription[type] || this.attachmentType.secondary.secondaryDescription.self
    },
    getRelationshipPattern() {
      const type = this.assessmentType === 'self' ? 'self' : 'partner'
      return this.primaryType.relationshipPattern[type] || this.primaryType.relationshipPattern.self
    },
    getAdvice() {
      const type = this.assessmentType === 'self' ? 'self' : 'partner'
      return this.primaryType.advice[type] || this.primaryType.advice.self
    }
  }
}
</script>

